module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card border-0  h-100"
  }, [_c('div', {
    staticClass: "card-header",
    style: ({
      backgroundColor: _vm.item.options.border_top_color
    })
  }, [_c('h5', {
    style: ({
      color: _vm.item.options.text_border_color
    })
  }, [_vm._v("\n           " + _vm._s(_vm.page.title) + "\n           "), (_vm.finished) ? _c('span', [_vm._v("\n               ("), _c('i', {
    staticClass: "fa fa-file-certificate"
  }), _vm._v("  Zertifikat erstellt)\n           ")]) : _vm._e()])]), _vm._v(" "), (_vm.page.type === 'content' || _vm.page.type === 'success_page') ? _c('div', {
    staticClass: "card-body d-flex flex-column",
    style: ({
      backgroundColor: _vm.item.options.background_color,
      color: _vm.item.options.text_color
    })
  }, [(_vm.page.layout === 'center') ? _c('CenterComponent', {
    attrs: {
      "background_image": _vm.page.background_image
    }
  }) : _vm._e(), _vm._v(" "), (_vm.page.layout === 'text') ? _c('TextComponent', {
    attrs: {
      "content": _vm.page.content
    }
  }) : _vm._e(), _vm._v(" "), (_vm.page.layout === 'toptextdownpic') ? _c('toptextdownpic', {
    attrs: {
      "content": _vm.page.content,
      "background_image": _vm.page.background_image
    }
  }) : _vm._e(), _vm._v(" "), (_vm.page.layout === 'leftpicrighttext') ? _c('leftpicrighttext', {
    attrs: {
      "content": _vm.page.content,
      "background_image": _vm.page.background_image
    }
  }) : _vm._e(), _vm._v(" "), (_vm.page.layout === 'lefttextrightpic') ? _c('lefttextrightpic', {
    attrs: {
      "content": _vm.page.content,
      "background_image": _vm.page.background_image
    }
  }) : _vm._e(), _vm._v(" "), (_vm.page.layout === 'youtube') ? _c('Youtube', {
    attrs: {
      "content": _vm.page.content,
      "video_id": _vm.page.video_id
    }
  }) : _vm._e()], 1) : _c('div', {
    staticClass: "card-body d-flex justify-content-center align-items-center",
    style: ({
      backgroundColor: _vm.item.options.background_color,
      color: _vm.item.options.text_color
    })
  }, [(_vm.page.type === 'questiongroup') ? [_c('div', {
    staticClass: "mx-auto justify-content-center align-items-center min-w-50"
  }, [_c('div', [(_vm.item.options.question_header_size == 'h6') ? _c('h6', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.text)
    }
  }) : (_vm.item.options.question_header_size == 'h4') ? _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.text)
    }
  }) : (_vm.item.options.question_header_size == 'h3') ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.text)
    }
  }) : (_vm.item.options.question_header_size == 'h2') ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.text)
    }
  }) : (_vm.item.options.question_header_size == 'h1') ? _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.text)
    }
  }) : _c('h5', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.text)
    }
  })]), _vm._v(" "), (_vm.item.options.show_question_result_text) ? [(_vm.question_wrong) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.item.options.question_wrong_text)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.question_right) ? _c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "role": "alert"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.item.options.question_right_text)
    }
  }) : _vm._e()] : [(_vm.question_wrong || _vm.question_right) ? _c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "role": "alert"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.item.options.question_answered_text)
    }
  }) : _vm._e()], _vm._v(" "), _vm._l((_vm.Answers), function(answer, index) {
    return (_vm.question.type === 'multi') ? _c('div', {
      staticClass: "custom-control custom-checkbox pt-2",
      class: _vm.item.options.question_size
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.answere_checked),
        expression: "answere_checked"
      }],
      staticClass: "custom-control-input",
      attrs: {
        "type": "checkbox",
        "id": 'checkbox_' + _vm.question_index + '_' + index
      },
      domProps: {
        "value": answer.value + '_' + answer.id,
        "checked": Array.isArray(_vm.answere_checked) ? _vm._i(_vm.answere_checked, answer.value + '_' + answer.id) > -1 : (_vm.answere_checked)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.answere_checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = answer.value + '_' + answer.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.answere_checked = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.answere_checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.answere_checked = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "custom-control-label",
      attrs: {
        "for": 'checkbox_' + _vm.question_index + '_' + index
      }
    }, [_vm._v(_vm._s(answer.text))])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.Answers), function(answer, index) {
    return (_vm.question.type === 'single') ? _c('div', {
      staticClass: "form-check",
      class: _vm.item.options.question_size
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.answere_checked),
        expression: "answere_checked"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": answer.value + '_' + answer.id,
        "checked": _vm._q(_vm.answere_checked, answer.value + '_' + answer.id)
      },
      on: {
        "change": function($event) {
          _vm.answere_checked = answer.value + '_' + answer.id
        }
      }
    }), _vm._v(" "), _vm._l((answer.text.split('-')), function(text, index) {
      return (index > 1 && answer.text.contains('-')) ? _c('label', {
        staticClass: "form-check-label row"
      }, [_vm._v("- " + _vm._s(text))]) : _c('label', {
        staticClass: "form-check-label row ml-1"
      }, [_vm._v(_vm._s(answer.text))])
    })], 2) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.Answers), function(answer, index) {
    return (_vm.question.type === 'input') ? _c('div', {
      staticClass: "input-group mb-3",
      class: _vm.item.options.question_size
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.answere_checked),
        expression: "answere_checked"
      }],
      ref: "input",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "step": _vm.input_step
      },
      domProps: {
        "value": (_vm.answere_checked)
      },
      on: {
        "blur": _vm.roundInput,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.answere_checked = $event.target.value
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "input-group-append"
    }, [_c('span', {
      staticClass: "input-group-text"
    }, [_vm._v(_vm._s(_vm.question.input_question_unit))])])]) : _vm._e()
  }), _vm._v(" "), (_vm.question.type === 'yesno') ? _c('div', {
    staticClass: "custom-control",
    class: _vm.item.options.question_size
  }, [_c('div', {
    staticClass: "btn-group w-100",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    class: 'btn ' + _vm.yesno_yes_button_class,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.checkAnswer(_vm.question.answers[0].value + '_0')
      }
    }
  }, [_vm._v(_vm._s(_vm.question.answers[0].text))]), _vm._v(" "), _c('button', {
    class: 'btn ml-1 ' + _vm.yesno_no_button_class,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.checkAnswer(_vm.question.answers[1].value + '_1')
      }
    }
  }, [_vm._v(_vm._s(_vm.question.answers[1].text))])])]) : _vm._e(), _vm._v(" "), (_vm.question.type === 'selection') ? _c('div', {
    staticClass: "pt-3",
    class: _vm.item.options.question_size
  }, _vm._l((_vm.Answers), function(answer, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm"
    }, [_c('label', {}, [_vm._v(_vm._s(answer.text))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.answere_checked[index]),
        expression: "answere_checked[index]"
      }],
      attrs: {
        "id": 'select_' + _vm.question_index + '_' + index
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.answere_checked, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.allQuestionAnsweres), function(option) {
      return _c('option', {
        domProps: {
          "value": option,
          "innerHTML": _vm._s(option)
        }
      })
    }), 0)])])
  }), 0) : _vm._e()], 2)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "card-footer text-muted ",
    style: ({
      backgroundColor: _vm.item.options.border_bottom_color
    })
  }, [_c('div', {
    staticClass: "container row"
  }, [_c('div', {
    staticClass: "text-left col-6"
  }, [((_vm.item.options.question_go_back && _vm.page.type === 'questiongroup') || (_vm.page.type === 'success_page' && _vm.item.options.confirm_delivery)) ? _c('div', {
    staticClass: "col-6"
  }, [(_vm.cangoBack) ? _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backpage
    }
  }, [_vm._v("Zurück")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.item.options.show_question_answer == '1' && _vm.page.type == 'questiongroup' && _vm.question.type == 'multi') ? _c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n                    mögliche richtige Antwort:\t (" + _vm._s(_vm.CountCorrectAnswer) + ")\n                    "), (false) ? _c('div', [_vm._v("\n                        Frage " + _vm._s(_vm.question_index + 1) + " / " + _vm._s(_vm.questions.length) + "\n                    ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-right col-6"
  }, [(_vm.page.type === 'content') ? _c('div', {
    staticClass: "btn-group ",
    attrs: {
      "role": "group",
      "aria-label": "Basic example"
    }
  }, [(_vm.cangoBack) ? _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backpage
    }
  }, [_vm._v("Zurück")]) : _vm._e(), _vm._v(" "), (_vm.cangoNext) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.nextpage
    }
  }, [_vm._v("Weiter")]) : _vm._e()]) : (_vm.page.type === 'questiongroup' && _vm.question.type !== 'yesno') ? _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Basic example"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkAnswer()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.item.options.answere_button_text))])]) : (_vm.page.type === 'success_page' && _vm.item.options.confirm_delivery) ? _c('div', [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.markSuccess()
      }
    }
  }, [_vm._v(" Abgabe")])]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a62b3e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Player.vue
// module id = 116
// module chunks = 0